import Service from "../Service";
const resource = "TasProducerContract/";
import Vue from "vue";


export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    ExpiredContractList(usrID, requestID) {
        return Service.post(resource + "ExpiredContractList", {}, {
            params: { UsrID: usrID, requestID: requestID },
        });
    },

    getUrllistProducerFarmLot() {
        return Vue.prototype.$http.defaults.baseURL + "/TasProducerContract/listProducerFarmLot";
    },

    ProducerCategorization(parameters, requestID) {
        return Service.post(resource + "ProducerCategorization", parameters, {
            params: { requestID: requestID },
        });
    },
    FarmLotProducerList(PrdID, requestID) {
        return Service.post(resource + "FarmLotProducerList", {}, {
            params: {
                PrdID: PrdID,
                requestID: requestID
            },
        });
    },

    ProducerContractDetailList(PctID, requestID) {
        return Service.post(resource + "ProducerContractDetailList", {}, {
            params: {
                PctID: PctID,
                requestID: requestID
            },
        });
    },

    getUrlResponsibleCollectingFarmLot() {
        return Vue.prototype.$http.defaults.baseURL + "/TasProducerContract/ResponsibleCollectingFarmLot";
    },

    AddendaList(PcdID, requestID) {
        return Service.post(resource + "AddendaList", {}, {
            params: {
                PcdID: PcdID,
                requestID: requestID
            },
        });
    },

};